import { render, staticRenderFns } from "./PotentialResourcesPlatform.vue?vue&type=template&id=a72ad90c&scoped=true&"
import script from "./PotentialResourcesPlatform.vue?vue&type=script&lang=js&"
export * from "./PotentialResourcesPlatform.vue?vue&type=script&lang=js&"
import style0 from "./PotentialResourcesPlatform.vue?vue&type=style&index=0&id=a72ad90c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72ad90c",
  null
  
)

export default component.exports